import useLocalStorage from 'react-localstorage-hook';

import { useSwitchChain as useSwitchChainWagmi } from 'wagmi';

import { ConfigChainIds } from '@tools/wagmi';

import { mapWagmiError } from '@helpers/common/error.helpers';

import showToast from '@components/common/Toast';

import { CURRENT_CHAIN_ID } from '@constants/common/localStorage.constants';
import { ToastType } from '@constants/common/toast.constants';

export const useSwitchChain = () => {
  const [, onChangeChain] = useLocalStorage(CURRENT_CHAIN_ID);

  const { chains, switchChainAsync, isPending } = useSwitchChainWagmi();

  const switchChain = async (id: ConfigChainIds) => {
    try {
      await switchChainAsync({ chainId: id });
      onChangeChain(id);
    } catch (e) {
      showToast({ title: mapWagmiError(e as Error) }, ToastType.Error);
    }
  };

  return {
    switchChain,
    chains,
    isPending,
  };
};
